export default function ($time) {

  // <a>タグクリックのイベントをキャンセルし、
  // JSで遷移させる。

  let timeout = 0;
  if ($time) timeout += $time;

  Cookies.remove('rejectPegeMove', { path: '/' });

  $(document).on('click', 'a:not(".reject-pegeMove")', (e) => {
    $('body').removeClass('is-reject');

    const $link = $(e.currentTarget);

    const waitPageMove = (e) => {
      e.preventDefault();
      setTimeout(() => {
        $('.c-pagemove').show();
        $('body').addClass('is-beforemove');
      }, timeout);
      setTimeout(() => {
        $('.c-pointer').find('div').fadeOut(300);
      }, timeout + 300);
      setTimeout(() => {
        location = $link.attr('href');
      }, timeout+500);
    };

    // [Win: ctrl, mac: cmd] が押されていないとき
    if (!e.metaKey && !e.ctrlKey) {
      if($link.hasClass('js-force-pagemove')) {
        waitPageMove(e);
      } else if ($link.attr('target') != '_blank' && !$link.hasClass('no-moveanime') && !$link.attr('href').match(/^#/) && !$link.attr('href').match('tel:') && !$link.attr('href').match('mailto:') ) {
        waitPageMove(e);
      }
    };

  })

  //ページのアニメーションフェードのみに
  $(document).on('click', 'a.reject-pegeMove', (e) => {
    const $link = $(e.currentTarget);
    Cookies.set('rejectPegeMove', 'reject', { path: '/' });
    e.preventDefault();
    $('body').addClass('prev-state')
    $('.l-page__inner').fadeOut(200, function() {
      location.href = $link.attr('href');
    });
  })

}

// iOS Safari ブラウザバック対策
// ブラウザバックで発火するイベントはないのでpopstateイベントで代替
history.replaceState(null, document.getElementsByTagName('title')[0].innerHTML, null);
window.addEventListener('popstate', function(e) {
  location.reload();
});
